import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_2 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_3 = {
  key: 1,
  class: "form-body"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { for: "frm-interestedForm_email" }
const _hoisted_6 = ["readonly"]
const _hoisted_7 = {
  key: 0,
  class: "form-error"
}
const _hoisted_8 = {
  key: 1,
  class: "form-error"
}
const _hoisted_9 = { for: "frm-interestedForm_phone" }
const _hoisted_10 = {
  key: 0,
  class: "form-error"
}
const _hoisted_11 = { for: "frm-interestedForm_subject" }
const _hoisted_12 = { class: "selectbox" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "form-error"
}
const _hoisted_15 = { for: "frm-interestedForm_message" }
const _hoisted_16 = {
  key: 0,
  class: "form-error"
}
const _hoisted_17 = {
  key: 0,
  class: "form-footer is-inline"
}
const _hoisted_18 = { class: "checkbox" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "form-error"
}
const _hoisted_22 = { class: "buttons-wrap" }
const _hoisted_23 = {
  type: "submit",
  class: "button button--primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlashMessage = _resolveComponent("FlashMessage")!

  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
    autocomplete: "off"
  }, [
    (_ctx.showFormMessages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
            return (_openBlock(), _createBlock(_component_FlashMessage, {
              key: index,
              message: message
            }, null, 8, ["message"]))
          }), 128)),
          (_ctx.isError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flashmessage flash-danger"
            }, _toDisplayString(error), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
            }, [
              _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('AdInterestedForm.email')) + ":", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                readonly: !_ctx.isEstateAgencyMode,
                type: "text",
                id: "frm-interestedForm_email",
                name: "email",
                class: "form-control"
              }, null, 8, _hoisted_6), [
                [
                  _vModelText,
                  _ctx.v$.form.email.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.v$.form.email.required.$invalid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('forms.required')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.v$.form.email.email.$invalid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('forms.email')), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phone.$error }])
            }, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('AdInterestedForm.phone')) + ":", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.phone.$model) = $event)),
                type: "text",
                id: "frm-interestedForm_phone",
                name: "phone",
                class: "form-control"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.v$.form.phone.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.v$.form.phone.$dirty && _ctx.v$.form.phone.$invalid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.v$.form.phone.required.$invalid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('forms.required')), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.subject.$error }])
          }, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('AdInterestedForm.subject')) + ":", 1),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                id: "frm-interestedForm_subject",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.subject.$model) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubjectChange && _ctx.onSubjectChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjects, (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: item.title
                  }, _toDisplayString(item.title), 9, _hoisted_13))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.v$.form.subject.$model]
              ]),
              (_ctx.v$.form.subject.$dirty && _ctx.v$.form.subject.$invalid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.v$.form.subject.required.$invalid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('forms.required')), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.message.$error }])
          }, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('AdInterestedForm.message')) + ":", 1),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.message.$model) = $event)),
              id: "frm-interestedForm_message",
              class: "form-control",
              rows: "5",
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onMessageChange && _ctx.onMessageChange(...args)))
            }, null, 544), [
              [
                _vModelText,
                _ctx.v$.form.message.$model,
                void 0,
                { trim: true }
              ]
            ]),
            (_ctx.v$.form.message.$dirty && _ctx.v$.form.message.$invalid)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.v$.form.message.required.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('forms.required')), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 2),
          (!_ctx.isEstateAgencyMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.personalAgreement.$error }])
                }, [
                  _createElementVNode("label", _hoisted_18, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$t('AdInterestedForm.personal-agreement', { privacyUrl: _ctx.privacyUrl, domain: _ctx.domain })
                    }, null, 8, _hoisted_19),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.personalAgreement.$model) = $event)),
                      type: "checkbox",
                      id: "frm-interestedForm_personalAgreement",
                      name: "personalAgreement"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.v$.form.personalAgreement.$model]
                    ]),
                    _hoisted_20
                  ]),
                  (_ctx.v$.form.personalAgreement.$dirty && _ctx.v$.form.personalAgreement.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.personalAgreement.sameAs.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.$t('forms.send')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 32))
}